import { ChannelType, Iab, Network, PositionCreateInput, SubChannelType } from '../../../__generated__/graphql'

export type PositionCreateFormValues = PositionCreateInput

export const buildPositionCreateFormInitialValues = (
  websiteIabCategory?: Iab | string | null
): PositionCreateFormValues => ({
  name: '',
  iabCategory: (websiteIabCategory as Iab) || Iab.Iab24,
  channelType: ChannelType.Email,
  nbZone: 4,
  revenueShare: 60,
  websiteId: '',
  network: Network.Media,
  subchannelType: SubChannelType.Newsletter,
  cpmFloor: 0,
})
